module.exports = "<div class=\"modal-header modal_head moveCursor\">\r\n    <button *ngIf=\"showClose\" type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"modal.dismiss()\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n    <ng-content></ng-content>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./app/shared/modeldialog/template/modal-header.template.html
// module id = 604
// module chunks = 3